import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import useInView from "./utils/useInView";
import { useAd, useGetAd } from "./stores/otherStore";
import "swiper/css";
import "swiper/css/pagination";

const AdBlog = () => {
    const [ref, inView] = useInView();
    const ad = useAd();
    const getAd = useGetAd();
    const swiperRef = useRef(null);

    useEffect(() => {
        void getAd();
    }, [getAd]);

    useEffect(() => {
        const swiperInstance = swiperRef.current?.swiper;

        // Иногда autoplay не стартует при первом рендере, фикс:
        if (swiperInstance && swiperInstance.autoplay) {
            swiperInstance.autoplay.stop();
            // Немного задерживаем запуск — чтобы DOM и Swiper инициализировались
            setTimeout(() => {
                swiperInstance.slideToLoop(0, 0); // переходим на первый слайд без анимации
                swiperInstance.autoplay.start();
            }, 300);
        }
    }, [ad]); // запускаем, когда данные подгрузились

    useEffect(() => {
        if (inView && swiperRef.current?.swiper?.autoplay) {
            swiperRef.current.swiper.autoplay.start();
        }
    }, [inView]);

    if (!ad) return null;

    return (
        <div
            ref={ref}
            className={`opacity-0 scale-90 transition-all duration-500 ${
                inView ? "animate-fadeIn" : ""
            }`}
        >
            <div className="container">
                <Swiper
                    ref={swiperRef}
                    modules={[Pagination, Autoplay]}
                    slidesPerView={1}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                    pagination={{ clickable: true }}
                    loop={true}
                >
                    {ad.map((a) => (
                        <SwiperSlide key={a.id}>
                            <img
                                className="w-full lg:px-36 lg:h-[65vh] h-[45vh]"
                                src={a.url}
                                alt=""
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default AdBlog;
